import React, { memo, useState } from "react";
import { Link } from "react-router-dom";
import { Wrap } from "./style";

export default memo(function Menu() {
  const menuHandle = () => {
    setMenuState(!menuState);
  };
  const [menuState, setMenuState] = useState(false);
  const [items] = useState([
    {
      name: "投资者常见问题",
      path: "/Theme",
    },
    {
      name: "我要提问",
      path: "/Answer",
    },
    {
      name: "更多投资者信息",
      path: "http://www.sinochemintl.com/12732.html",
    },
  ]);
  return (
    <Wrap>
      <div className='logo'>
        <img src={require("../../assets/img/1_05.png").default} alt='logo' />
      </div>
      <div
        className={"menuBtn" + (menuState ? " close" : "")}
        onClick={menuHandle}>
        <div className='menu-item'></div>
        <div className='menu-item'></div>
        <div className='menu-item'></div>
      </div>
      <div className={"menuList" + (menuState ? " close" : "")}>
        {items.slice(0, 2).map((item) => {
          return (
            <Link className='menuList-item' to={item.path} key={item.name}>
              <h5>{item.name}</h5>
              <h5>
                <img src={require("../../assets/img/1.svg").default} alt='' />
              </h5>
            </Link>
          );
        })}
        {items.slice(2, 3).map((item) => {
          return (
            <a className='menuList-item' href={item.path} key={item.name}>
              <h5>{item.name}</h5>
              <h5>
                <img src={require("../../assets/img/1.svg").default} alt='' />
              </h5>
            </a>
          );
        })}
      </div>
    </Wrap>
  );
});
